<template>
    <div class="sidebar d-flex align-items-end relative alt">

        <img class="smallLogo" src="/static/images/common/logo_small_red_white.svg">

        <img class="img-fluid" src="/static/images/auth/signup.jpg">

        <div class="text text-left">
            <!-- <div v-if="name" class="fs-larger lightest">Hey {{ name }}!</div> -->
            <div class="fs-largest lightest headline"><b>Hey {{ name }}!</b><br>Let us know about yourself.</div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'accountSetup',
            ]),
            name: function() {
                if (this.accountSetup.name !== undefined) {
                    return this.accountSetup.name;
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .smallLogo{
        width: 31px;
        position: absolute;
        top: 20px;
        left: 20px;
    }

    .headline{
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>



// WEBPACK FOOTER //
// CreateSidebar.vue?49b1ee34